export const isSuccessEndUrls = (fullUrl: string) => {
    if (fullUrl.indexOf("postCode=sas-success") !== -1) {
        // this is the end of the AeS process in swisscom:
        // url -->  https://ais-sas.swisscom.com/sas/web/success?lang=en&postCode=sas-success
        return true;
    }
    if (fullUrl.indexOf("__bypass_signing_accept") !== -1) {
        // this is a redirect in the backend, check skribble django views
        // basquiat_service.skribble.views.signature_webhook to see the logic
        return true;
    }
    // check that the path of the url contains the string "_skribble/_red/"
    // only the path must contains the string, not the full url
    try {
        const url = new URL(fullUrl);
        if (url.pathname.indexOf("_skribble/_red/") !== -1) {
            // this is a redirect in the backend, check skribble django views
            // basquiat_service.skribble.views.signature_webhook to see the logic
            return true;
        }
    } catch (e) {
        console.error("Error parsing url", e);
    }
    return false;
};

export const isCancelEndUrls = (fullUrl: string) => {
    if (fullUrl.indexOf("__bypass_signing_cancel") !== -1) {
        // this is a redirect in the backend, check skribble django views
        // basquiat_service.skribble.views.bypass_signing to see the logic
        return true;
    }
    if (fullUrl.indexOf("postCode=sas-error-user-cancelled") !== -1) {
        // this is the end of the AeS process in swisscom:
        // https://ais-sas.swisscom.com/sas/web/error?lang=fr&errorCode=authenticationFailed.canceledByUser&postCode=sas-error-user-cancelled
        return true;
    }
    if (fullUrl === "__cancel__") {
        return true;
    }
    return false;
};

/**
 * This must be called AFTER isCancelEndUrls
 */
export const isFailEndUrls = (fullUrl: string) => {
    if (fullUrl.indexOf("my.skribble.com/sorry") !== -1) {
        // Generic Skribble fail url
        return true;
    }
    if (fullUrl.indexOf("__bypass_signing_reject") !== -1) {
        // this is a redirect in the backend, check skribble django views
        // basquiat_service.skribble.views.signature_webhook to see the logic
        return true;
    }
    if (fullUrl.indexOf("postCode=sas-error-invalid-transaction-token") !== -1) {
        // this is the end of the AeS process in swisscom:
        // https://ais-sas.swisscom.com/sas/web/error?lang=fr&errorCode=authenticationFailed.invalidTransaction&postCode=sas-error-invalid-transaction-token
        return true;
    }
    if (fullUrl.indexOf("postCode=sas-error") !== -1) {
        // this is the end of the AeS process in swisscom:
        return true;
    }
    return false;
};
